import { render, staticRenderFns } from "./AwsFilesModalList.vue?vue&type=template&id=5760dadd&scoped=true"
import script from "./AwsFilesModalList.vue?vue&type=script&lang=ts"
export * from "./AwsFilesModalList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760dadd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5760dadd')) {
      api.createRecord('5760dadd', component.options)
    } else {
      api.reload('5760dadd', component.options)
    }
    module.hot.accept("./AwsFilesModalList.vue?vue&type=template&id=5760dadd&scoped=true", function () {
      api.rerender('5760dadd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AwsFilesModalList.vue"
export default component.exports